<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>Chỉnh sửa mã input</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <div class="row">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>Tên trường dữ liệu</mat-label>
                    <input matInput disabled placeholder="Tên trường dữ liệu" [value]="data.attribute.name">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>Mã trường dữ liệu</mat-label>
                    <input matInput placeholder="Mã trường dữ liệu" [formControl]="fieldNameControl">
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Hủy bỏ</button>
        <button mat-raised-button color="warn"
            (click)="onSaveAttribute()">Lưu</button>
    </mat-dialog-actions>
</div>